
export type ConfirmDeleteModalType = 'portfolio' | 'portfolioPage' | 'folder' | 'lesson';

class ConfirmDeleteModalController {
    
    private close:Function; //injected from modal-service
    private closeCallback:Function;
    
    public deleteAction: string = 'delete';
    public title: string;
    public baseObjectId: string;
    public type: ConfirmDeleteModalType;
    public folderType: 'portfolio' | 'lesson';
    public unfollowShare: boolean = false;
	
	// @ngInject
	constructor(
		public $timeout : ng.ITimeoutService,
		public ModalService	
	){}
	
	public onConfirmDelete = () => {
	    this.closeModal(true);
	}
	
    private closeModal = (confirmDelete = false) =>{
		if(this.closeCallback != null){
			this.closeCallback()(confirmDelete);
		}
		
		if(this.close != null){
			this.close();
		}
		
		this.ModalService.closeModals();
    }
    
}

class ConfirmDeleteModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    title: "<",
	    baseObjectId: "<",
	    deleteAction: "<?",
	    type: "<",
	    folderType: "<?",
	    close:'&?',
		closeCallback:'&',
		unfollowShare: "<",
	};

	public controller = ConfirmDeleteModalController;
	public controllerAs = 'confirmDeleteModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/confirm-delete-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ConfirmDeleteModal };
